import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { Website } from '@models/peripherals/website';
import { WebsiteForm } from '@models/peripherals/website-form';
import { ConfirmPopupComponent } from '@shared/modal-popup/confirm-popup/confirm-popup.component';
@Component({
  selector: 'app-websitearray',
  templateUrl: './websitearray.component.html',
  styleUrls: ['./websitearray.component.css']
})
export class WebsitearrayComponent implements OnInit {
  @ViewChild(ConfirmPopupComponent) confirmModal: ConfirmPopupComponent;
  public isCollapsed = true;
  private websiteType: string[];
  selectColor = '#aaaaaa';
  websiteCounter: number;

  @Input()
  public websiteForm: WebsiteForm[];

  @Input()
  public websiteFormArray: FormArray;

  @Input()
  public parentId: number;

  @Output() deleteWebsiteEvent: EventEmitter<number> = new EventEmitter();

  static buildWebsites() {
    return new FormArray([
      this.buildWebsite(''),
    ]);
  }

  static buildFormWebsite(val: WebsiteForm): any {
    return new FormGroup({
      website: new FormControl(val.url),
      website_id: new FormControl(val.websiteID)
    });
  }

  static buildWebsite(val: string): any {
    return new FormGroup({
      website: new FormControl(val),
      website_id: new FormControl(null)
    });
  }

  ngOnInit() {

    if (this.websiteForm) {
      this.websiteFormArray.removeAt(0);
      this.websiteForm.forEach(element => {
        this.websiteFormArray.push(WebsitearrayComponent.buildFormWebsite(element));
      });
    }
    this.websiteCounter = this.websiteForm.length;
  }

  addWebsite() {
    this.websiteFormArray.push(WebsitearrayComponent.buildWebsite(''));
    this.isCollapsed = false;
    this.websiteCounter = this.websiteCounter + 1;
  }

  changetxtRecord() {
    this.selectColor = '#000000';
  }

  deleteWebsite(index) {
    const website_id = this.websiteFormArray.controls[index.map_id].get('website_id').value;

    if (this.parentId) {

      this.deleteWebsiteEvent.emit(website_id);
      this.websiteFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
    } else {
      this.websiteFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
    }
    this.websiteCounter = this.websiteCounter - 1;
  }
  validUrl(event, form) {
    const value = event.target.value;
    const pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    if (value !== '' && !pattern.test(value)) {
      alert('Enter Valid Url (eg.facebook.com)');
      form.controls['website'].setValue(null, { onlySelf: true });
    }
  }

  openConfirm(id) {
    this.confirmModal.showModal(id);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-control/website-form-control/websitearray.component.ts